import { render, staticRenderFns } from "./SceneViewEngine.vue?vue&type=template&id=0bc7f946&scoped=true"
import script from "./SceneViewEngine.vue?vue&type=script&lang=js"
export * from "./SceneViewEngine.vue?vue&type=script&lang=js"
import style0 from "./SceneViewEngine.vue?vue&type=style&index=0&id=0bc7f946&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc7f946",
  null
  
)

export default component.exports